import React, { useState, useEffect } from 'react';
import { useLocation,useNavigate } from 'react-router-dom';
import { addCustomer,fetchClients,updateClient } from '../api/api';
import '../css/style.css';

const Add = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const customerId = queryParams.get('id'); // get id if editing

  //toggle eye
  const [isCustomerPasswordVisible, setCustomerPasswordVisible] = useState(false);
  const [isDbPasswordVisible, setDbPasswordVisible] = useState(false);

  const [formData, setFormData] = useState({
    cust_name: '',
    email: '',
    password: '',
    db_host: '',
    db_name: '',
    db_user: '',
    db_pass: '',
    client_code: ''
  });

  useEffect(() => {
  const loadCustomer = async () => {
    if (!customerId) {
      // 🔹 Add mode: clear all fields
      setFormData({
        cust_name: '',
        email: '',
        password: '',
        db_host: '',
        db_name: '',
        db_user: '',
        db_pass: '',
        client_code: ''
      });
      return;
    }

    // 🔹 Edit mode: fetch existing client data
    try {
      const clients = await fetchClients(); 
      const client = clients.find(c => c.id === parseInt(customerId));
      if (client) {
        setFormData({
          cust_name: client.name,
          email: client.email,
          password: client.password,
          db_host: client.db_host,
          db_name: client.db_name,
          db_user: client.db_user,
          db_pass: client.db_pass,
          client_code: client.client_code
        });
      }
    } catch (err) {
      console.error('Failed to load client for editing:', err);
    }
  };

  loadCustomer();
}, [customerId]); // 👈 this runs automatically whenever you change routes


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (customerId) {
        // Edit mode -> update
        await updateClient(formData);
        alert('Customer updated successfully');
      } else {
        // Add mode -> create
        await addCustomer(formData);
        alert('Customer added successfully');
        setFormData({
          cust_name: '',
          email: '',
          password: '',
          db_host: '',
          db_name: '',
          db_user: '',
          db_pass: '',
          client_code: ''
        });
      }
      navigate('/customer-list'); // redirect back to customer list after save
    } catch (error) {
      console.error('Failed to save customer:', error);
      alert('Failed to save customer');
    }
  };

  //enter and tab key function
  const handleKeyDown = (e) => {
  if (e.key === "Enter") {
    e.preventDefault(); // stop form submission
    const form = e.target.form; // get current form
    const index = Array.prototype.indexOf.call(form, e.target);
    const next = form.elements[index + 1];
    if (next) {
      next.focus(); // move to next input
    }
  }
};


  return (
    <div className="form-page">
      <div className="form-sheet">
        <h2 className="form-title">{customerId ? 'Edit Customer' : 'Add New Customer'}</h2>
        <form className="crm-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Customer Name</label>
            <input
              type="text"
              name="cust_name"
              placeholder="Enter customer name"
              value={formData.cust_name}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
            />
          </div>

          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              name="email"
              placeholder="Enter email address"
              value={formData.email}
              onChange={handleChange}
              autoComplete="new-email"
              onKeyDown={handleKeyDown}
            />
          </div>

          <div className="form-group">
            <label>Customer Password</label>
            <div className="pass-group">
              <input
                type={isCustomerPasswordVisible ? "text" : "password"}
                name="password"
                placeholder="Enter customer password"
                value={formData.password}
                onChange={handleChange}
                autoComplete="new-password"
                className="pass-input"
                onKeyDown={handleKeyDown}
              />
              <span
                className="toggle-password"
                onClick={() => setCustomerPasswordVisible(prev => !prev)}
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M12 5C7 5 2.73 8.11 1 12c1.73 3.89 6 7 11 7s9.27-3.11 11-7c-1.73-3.89-6-7-11-7zm0 12a5 5 0 110-10 5 5 0 010 10zm0-8a3 3 0 100 6 3 3 0 000-6z"/>
                </svg>
                {!isCustomerPasswordVisible && <span className="eye-line"></span>}
              </span>
            </div>
          </div>


          <div className="form-group">
            <label>Database Host</label>
            <input
              type="text"
              name="db_host"
              placeholder="Enter database Host"
              value={formData.db_host}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
            />
          </div>

          <div className="form-group">
            <label>Database Name</label>
            <input
              type="text"
              name="db_name"
              placeholder="Enter database name"
              value={formData.db_name}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
            />
          </div>

          <div className="form-group">
            <label>Database Username</label>
            <input
              type="text"
              name="db_user"
              placeholder="Enter database username"
              value={formData.db_user}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
            />
          </div>

          <div className="form-group">
            <label>Database Password</label>
            <div className="pass-group">
              <input
                type={isDbPasswordVisible ? "text" : "password"}
                name="db_pass"
                placeholder="Enter database password"
                value={formData.db_pass}
                onChange={handleChange}
                autoComplete="new-password"
                className="pass-input"
                onKeyDown={handleKeyDown}
              />
              <span
                className="toggle-password"
                onClick={() => setDbPasswordVisible(prev => !prev)}
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M12 5C7 5 2.73 8.11 1 12c1.73 3.89 6 7 11 7s9.27-3.11 11-7c-1.73-3.89-6-7-11-7zm0 12a5 5 0 110-10 5 5 0 010 10zm0-8a3 3 0 100 6 3 3 0 000-6z"/>
                </svg>
                {!isDbPasswordVisible && <span className="eye-line"></span>}
              </span>
            </div>
          </div>

          <div className="form-group">
            <label>Client Code</label>
            <input
             type={customerId ? "password" : "text"}  // hides client code in edit mode
              name="client_code"
              placeholder="Enter client code"
              value={formData.client_code}
              onChange={handleChange}
              autoComplete="new-password"
              onKeyDown={handleKeyDown}
            />
          </div>
          {/* button to add customer/update customer */}
          <button type="submit">{customerId ? 'Update Customer' : 'Add Customer'}</button>
        </form>
      </div>
    </div>
  );
};

export default Add;
